import { render, staticRenderFns } from "./OMC.vue?vue&type=template&id=5b2a03c7&scoped=true"
import script from "./OMC.vue?vue&type=script&lang=js"
export * from "./OMC.vue?vue&type=script&lang=js"
import style0 from "./OMC.vue?vue&type=style&index=0&id=5b2a03c7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a03c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2a03c7')) {
      api.createRecord('5b2a03c7', component.options)
    } else {
      api.reload('5b2a03c7', component.options)
    }
    module.hot.accept("./OMC.vue?vue&type=template&id=5b2a03c7&scoped=true", function () {
      api.rerender('5b2a03c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/partials/OMC.vue"
export default component.exports